import { useTaskDialogStore } from '../hooks/useTaskDialogStore';
import { TaskDialog } from './TaskDialog';

export function GlobalTaskDialog() {
  const isOpen = useTaskDialogStore((s) => s.isOpen);
  const entryTaskId = useTaskDialogStore((s) => s.entryTaskId);
  const reset = useTaskDialogStore((s) => s.reset);

  if (!entryTaskId) return null;

  return (
    <TaskDialog
      taskId={entryTaskId}
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) reset();
      }}
    />
  );
}
